// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2zayv","errorLogs":"EditorFooter_errorLogs__3vaiA"};